import { useEffect, useState } from 'react';
import { fetchCouriers } from '../../../fetch/fetchCouriers';
import { fetchBundlesWithStatus } from '../../../pages/bundles/components/BundleUtils';
import { BundleStatus, CourierJson } from '../../../types/bundleTypes';

export const useGetCouriers = (): {
  isLoading: boolean;
  couriers: CourierJson[];
  assignedCourierIds: Set<number>;
} => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [couriers, setCouriers] = useState<CourierJson[]>([]);
  const [assignedCourierIds, setAssignedCourierIds] = useState<Set<number>>(
    new Set()
  );

  useEffect(() => {
    async function getCouriers() {
      const couriersFetched = (await fetchCouriers()).filter(
        courier => !courier.isLocked
      );
      const bundlesAssignedCourierIds = (
        await fetchBundlesWithStatus([
          BundleStatus.Draft,
          BundleStatus.Published,
          BundleStatus.Proposed,
          BundleStatus.Accepted,
        ])
      )
        .filter(bundle => !!bundle.assignedCourierId)
        .map(bundle => Number(bundle.assignedCourierId));

      setAssignedCourierIds(new Set(bundlesAssignedCourierIds));
      setCouriers(couriersFetched);
      setIsLoading(false);
    }
    getCouriers();
  }, []);

  return { isLoading, couriers, assignedCourierIds };
};
